import { useState } from "react";
import { Ban, ArrowRightLeft, AlertTriangle, BookOpen, ChevronDown, ChevronUp } from "lucide-react";

// WHAT THE AI READER TRIED, AND WHAT THE CODE DID WITH IT. His rule (2026-10-20): a value that is
// not on the sheet is never written to the truck — but it is never lost silently either.
const Row = ({ item, i, kind }) => (
  <div data-testid={`read-report-${kind}-${i}`} className="flex flex-wrap items-baseline gap-x-2 py-1 border-b border-slate-100 last:border-0">
    <span className="text-xs font-semibold text-slate-700">{item.label || item.field}</span>
    <span className="text-xs font-mono text-slate-500 line-through decoration-slate-300">{String(item.value ?? "")}</span>
    <span className="text-[11px] text-slate-500">{item.detail || item.why}</span>
  </div>
);

const Section = ({ icon: Icon, title, items, kind, tone }) => {
  const [open, setOpen] = useState(items.length <= 6);
  if (!items.length) return null;
  return (
    <div data-testid={`read-report-${kind}`} className={`rounded-lg border px-3 py-2 ${tone}`}>
      <button type="button" data-testid={`read-report-${kind}-toggle`} onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center gap-1.5 text-left min-h-[40px]">
        <Icon className="w-4 h-4 shrink-0" />
        <span className="text-sm font-bold flex-1">{title} ({items.length})</span>
        {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
      </button>
      {open && <div className="bg-white rounded-md px-2 mt-1">{items.map((it, i) => <Row key={i} item={it} i={i} kind={kind} />)}</div>}
    </div>
  );
};

export const AiReadReport = ({ report }) => {
  if (!report) return null;
  const held = report.held_back || [];
  const refiled = report.refiled || [];
  const unsure = report.unsure || [];
  const ref = report.reference_lines || 0;
  if (!held.length && !refiled.length && !unsure.length && !ref) return null;
  return (
    <div data-testid="ai-read-report" className="space-y-2">
      <div className="text-[11px] font-bold uppercase tracking-wider text-slate-500">What the AI reader tried — and what was done with it</div>
      <Section icon={Ban} kind="not-used" title="Not found on the sheet — not used" items={held}
        tone="border-red-200 bg-red-50 text-red-800" />
      <Section icon={ArrowRightLeft} kind="refiled" title="Filed somewhere else" items={refiled}
        tone="border-slate-200 bg-slate-50 text-slate-700" />
      <Section icon={AlertTriangle} kind="unsure" title="Written, marked unsure — check these first" items={unsure}
        tone="border-amber-200 bg-amber-50 text-amber-800" />
      {ref > 0 && (
        <div data-testid="read-report-reference" className="flex items-center gap-1.5 text-xs text-slate-500 px-1">
          <BookOpen className="w-3.5 h-3.5" />{ref} catalog / reference line{ref === 1 ? "" : "s"} on the sheet were left out — they are not about this truck.
        </div>
      )}
    </div>
  );
};
